var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNubePequeaCentradaAzulBirdybacker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 66,
    viewBox: "0 0 287 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 0H275.257C281.746 0 287 5.26021 287 11.7568C287 18.2534 281.746 23.5136 275.257 23.5136H132.206C127.468 23.5136 123.629 27.3576 123.629 32.1008C123.629 36.844 127.468 40.688 132.206 40.688H240.499C247.482 40.688 253.14 46.3529 253.14 53.344C253.14 60.3351 247.482 66 240.499 66H40.8204C34.219 66 28.8527 60.6499 28.8527 54.0184C28.8527 47.4094 34.1966 42.0368 40.8204 42.0368H71.2716C74.5182 42.0368 77.15 39.4049 77.15 36.1584C77.15 32.9118 74.5182 30.28 71.2716 30.28H15.1111C6.75844 30.28 0 23.5136 0 15.1512C0 6.78881 6.75844 0.0224672 15.1111 0.0224672V0Z",
    fill: "#B5EAD7",
    fillOpacity: 0.31
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNubePequeaCentradaAzulBirdybacker);
export default __webpack_public_path__ + "static/media/nube-pequeña-centrada-azul-birdybacker.59cc06358d1fe2ccce3c3081951c6e7c.svg";
export { ForwardRef as ReactComponent };